<ul class="ir-file-tree ir-file-container" *ngIf="nodes && nodes.length">
  <div *ngFor="let node of nodes">
    <li class="ir-file-node" *ngIf="!node.fileNode">
      <div class="ir-file-node-container" (click)="openNode(node)" [ngClass]="{ opened: node.opened }">
        <div class="ir-node-icon" (click)="showChildren(node, $event)">
          <div class="ir-node-icon-container" *ngIf="hasFolders(node)">
            <i *ngIf="node.children && node.children.length && !node.showChildren" class="material-icons"
              >keyboard_arrow_right</i
            >
            <i *ngIf="node.showChildren" class="material-icons">keyboard_arrow_down</i>
          </div>
        </div>
        <div class="ir-node-icon"><i class="material-icons">folder</i></div>
        <div class="ir-node-value">{{ node.name }}</div>
      </div>
      <div class="ir-node-items" *ngIf="node.showChildren && node.children && node.children.length">
        <folder-tree [nodes]="node.children" (toggleOpenNode)="openNode($event)"></folder-tree>
      </div>
    </li>
  </div>
</ul>
